import { Context, useContext, useMemo, createContext } from "react";
import { ClaimResult } from "../../../types/farming";
import { NotificationsContext } from "../../../App";
import { formatBalanceNumber } from "../../../communication/format";

export let SetBalanceContext: Context<(claim: ClaimResult) => void>;

export function UserProvider({ children }: { children: JSX.Element }) {
    const addNotification = useContext(NotificationsContext);

    const setBalance = (claim: ClaimResult) => {
        const sign = claim.claim_value > 0 ? "+" : "";
        addNotification(`${sign}${formatBalanceNumber(claim.claim_value)} Test Credits`);
    }

    SetBalanceContext = createContext(setBalance);

    const memoChildren = useMemo(() => children, [children]);

    return <SetBalanceContext.Provider value={setBalance}>
        {memoChildren}
    </SetBalanceContext.Provider>
}